import React from 'react';
import { withFormsy } from 'formsy-react';
import Radium from 'radium';
import Select from '../UIKit/Select';

class JumperFormsySelect extends React.Component {
  getPropsForState() {
    return Object.assign(
      {},
      this.showError() ? { error: true } : {},
      this.props.showRequired() ? { showRequired: true } : {},
    );
  }

  showRequired() {
    // empty method to silence console warning
  }

  showError() {
    if (this.props.isPristine()) {
      return false;
    }

    return !this.props.isValid();
  }

  extractInputProps() {
    const {
      setValidations,
      setValue,
      resetValue,
      getValue,
      hasValue,
      getErrorMessage,
      getErrorMessages,
      isFormDisabled,
      isValid,
      isPristine,
      isFormSubmitted,
      isRequired,
      showRequired,
      showError,
      isValidValue,
      validationError,
      validationErrors,
      value,
      ...inputProps
    } = this.props;

    return inputProps;
  }

  render() {
    const inputProps = this.extractInputProps();
    const validationProps = this.getPropsForState();
    const { getValue } = this.props;
    return (
      <Select
        value={getValue() || this.props.defaultValue}
        onChange={value => this.props.setValue(value)}
        {...inputProps}
        {...validationProps}
      />
    );
  }
}
export default withFormsy(Radium(JumperFormsySelect));



// WEBPACK FOOTER //
// ./src/components/Formsy/Select.js